/**
 *  @class
 *  @function CollectionTabsBar
 *  Slides the active-tab shape of the "Collection Tabs New" section and scrolls the tapped tab to the center.
 *  Switching tabs is still done by <tabs-component> (theme.js); this only follows its .active class.
 */

if (!customElements.get('collection-tabs-bar')) {
  class CollectionTabsBar extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.ctn-tabs__list');
      this.indicator = this.querySelector('.ctn-indicator');
      if (!this.list || !this.indicator) return;

      this.mutationObserver = new MutationObserver(() => this.update(true));
      this.mutationObserver.observe(this.list, { subtree: true, attributes: true, attributeFilter: ['class'] });

      // fonts, icons and viewport changes resize the tabs — re-place the shape without animating
      this.resizeObserver = new ResizeObserver(() => this.update(false));
      this.resizeObserver.observe(this.list);
      this.list.querySelectorAll('.ctn-tab').forEach((tab) => this.resizeObserver.observe(tab));

      this.update(false);
    }

    disconnectedCallback() {
      if (this.mutationObserver) this.mutationObserver.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    update(animate) {
      const tab = this.list.querySelector('.ctn-tab.active');
      if (!tab) return;

      const listRect = this.list.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();

      if (!animate) this.classList.add('ctn-no-anim');
      this.style.setProperty('--ctn-x', `${tabRect.left - listRect.left}px`);
      this.style.setProperty('--ctn-w', `${tabRect.width}px`);
      this.classList.add('is-ready');
      if (!animate) {
        this.indicator.getBoundingClientRect(); // apply the new position before transitions come back
        this.classList.remove('ctn-no-anim');
        return;
      }

      if (this.scrollWidth > this.clientWidth) {
        const left = this.scrollLeft + tabRect.left - this.getBoundingClientRect().left - (this.clientWidth - tabRect.width) / 2;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
  }

  customElements.define('collection-tabs-bar', CollectionTabsBar);
}